// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CartPageTemplate from "@conklin/App/Components/Cart/CartPageTemplate";
import XngZone from "@conklin/App/Components/Common/XngZone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface OnePageCheckoutConfirmationPageContainerStyles {
    container?: GridContainerProps;
    topGridItem?: GridItemProps;
    leftGridItem?: GridItemProps;
    spaceGridItem?: GridItemProps;
    rightGridItem?: GridItemProps;
    bottomGridItem?: GridItemProps;
}

export const containerStyles: OnePageCheckoutConfirmationPageContainerStyles = {
    topGridItem: { width: 12 },
    leftGridItem: {
        width: [12, 12, 6, 7, 7],
        css: css`
            & > div > div:not(:last-child) {
                padding-bottom: 30px;
                border-bottom: 1px solid ${getColor("common.border")};
            }
        `,
    },
    spaceGridItem: { width: [0, 0, 1, 1, 1] },
    rightGridItem: { width: [12, 12, 5, 4, 4] },
    bottomGridItem: {
        width: 12,
        css: css`
            & > div > div:first-child {
                padding-top: 30px;
                border-top: 1px solid ${getColor("common.border")};
            }
        `,
    },
};

const styles = containerStyles;

const OnePageCheckoutConfirmationPageContainer = ({ id }: Props) => {
    return (
        <CartPageTemplate extendedStyles={styles}> 
            <CartPageTemplate.MainSection>
                <XngZone contentId={id} zoneName="Content0" hint="Zone Content" />
            </CartPageTemplate.MainSection>
            <CartPageTemplate.CartTotalSection>
                <XngZone contentId={id} zoneName="Content1" hint="Zone For Order Total" />
            </CartPageTemplate.CartTotalSection>
        </CartPageTemplate>
    );
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutConfirmationPageContainer,
    definition: {
        displayName: "Page Container",
        group: "One Page Checkout Confirmation",
        allowedContexts: ["OnePageCheckoutConfirmationPage"],
    },
};

export default widgetModule;
